import { render, staticRenderFns } from "./DataObjectManagement.vue?vue&type=template&id=f56b283e&scoped=true"
import script from "./DataObjectManagement.vue?vue&type=script&lang=js"
export * from "./DataObjectManagement.vue?vue&type=script&lang=js"
import style0 from "./DataObjectManagement.vue?vue&type=style&index=0&id=f56b283e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56b283e",
  null
  
)

export default component.exports